import { render, staticRenderFns } from "./AbstractPagination.vue?vue&type=template&id=8e5b3714&scoped=true&"
import script from "./AbstractPagination.vue?vue&type=script&lang=js&"
export * from "./AbstractPagination.vue?vue&type=script&lang=js&"
import style0 from "./AbstractPagination.vue?vue&type=style&index=0&id=8e5b3714&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5b3714",
  null
  
)

export default component.exports